import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImg } from "../lib/api";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function HomeSlider() {
  const [slides, setSlides] = useState([]);
  const [i, setI] = useState(0);
  useEffect(() => { api.get("/slides").then(({ data }) => setSlides(data)); }, []);
  useEffect(() => {
    if (slides.length < 2) return;
    const t = setInterval(() => setI((p) => (p + 1) % slides.length), 5000);
    return () => clearInterval(t);
  }, [slides]);
  if (slides.length === 0) return null;
  const go = (d) => setI((p) => (p + d + slides.length) % slides.length);
  const s = slides[i];

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-8" data-testid="home-slider">
      <div className="relative h-[220px] md:h-[300px] overflow-hidden group">
        {slides.map((sl, idx) => (
          <Link key={sl.id} to={sl.link || "/kartini"}
                className="absolute inset-0 transition-opacity duration-700"
                style={{ opacity: idx === i ? 1 : 0, pointerEvents: idx === i ? "auto" : "none" }}>
            <img src={resolveImg(sl.image)} alt={sl.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-navy/70 via-navy/20 to-transparent" />
            <div className="absolute inset-0 flex flex-col justify-center px-8 md:px-14">
              <h3 className="font-serif text-2xl md:text-4xl text-white max-w-md">{sl.title}</h3>
              {sl.subtitle && <p className="text-ivory/85 mt-2 max-w-sm">{sl.subtitle}</p>}
            </div>
          </Link>
        ))}
        {slides.length > 1 && <>
          <button onClick={(e) => { e.preventDefault(); go(-1); }} className="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 bg-ivory/90 text-navy flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"><ChevronLeft size={18} /></button>
          <button onClick={(e) => { e.preventDefault(); go(1); }} className="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 bg-ivory/90 text-navy flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"><ChevronRight size={18} /></button>
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
            {slides.map((_, idx) => <button key={idx} onClick={(e) => { e.preventDefault(); setI(idx); }} className={`w-2 h-2 rounded-full ${idx === i ? "bg-gold" : "bg-ivory/60"}`} />)}
          </div>
        </>}
      </div>
    </section>
  );
}
